<div class="page-container">
  <div [@fadeInUp] class="login-card">
    <div class="logo-container">
      <img src="assets/img/logo-dark.png" />
    </div>

    <div [formGroup]="formGroup" class="form-container">
      <div>
        <h1>Pas de panique !</h1>
        <p>Vous aller recevoir un mail avec les instructions par email.</p>
      </div>
      <div>
        <mat-form-field>
          <mat-label>E-Mail</mat-label>
          <input matInput required formControlName="email" />
          <mat-hint>Veuillez renségner votre adresse email pour récuperer votre mot de passe</mat-hint>
          <mat-error *ngIf="formGroup.controls.email.invalid && (formGroup.controls.email.dirty || formGroup.controls.email.touched)">
            Champ obligatoire
          </mat-error>
          <mat-error *ngIf="formGroup.controls.email.errors?.pattern">Adresse email non valide</mat-error>
        </mat-form-field>
      </div>

      <div class="form-action">
        <button type="button" mat-raised-button (click)="send()">Envoyer</button>
      </div>

      <div class="form-action">
        <button class="return-btn" type="button" mat-raised-button [routerLink]="'/login'">Retour</button>
      </div>
    </div>
  </div>
</div>
